import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { ShieldCheck, AlertTriangle, Info, ChevronRight } from "lucide-react";

// «Τι λείπει» — owner home data-health card; each line links to the screen that fixes it.
export function DataHealthCard({ year }) {
  const { data } = useQuery({ queryKey: ["data-health", year], queryFn: async () => (await api.get(`/data-health${year ? `?year=${year}` : ""}`)).data, staleTime: 60000 });
  if (!data) return null;
  return (
    <div className="rounded-2xl bg-white border border-[#E3DED4] overflow-hidden" data-testid="data-health-card">
      <div className={`px-5 py-3 flex items-center gap-2 ${data.ok ? "bg-[#E2ECE4] text-[#3F6B4C]" : "bg-[#FBEFE6] text-[#9A4A22]"}`}>
        {data.ok ? <ShieldCheck className="h-5 w-5" /> : <AlertTriangle className="h-5 w-5" />}
        <span className="font-semibold text-sm">Τι λείπει · {data.year}</span>
        <span className="ml-auto text-xs opacity-80">{data.items.length ? `${data.items.length} σημεία` : "Όλα εντάξει"}</span>
      </div>
      {data.items.length > 0 && (
        <ul className="divide-y divide-[#F1EDE6]" data-testid="data-health-items">
          {data.items.map((i) => (
            <li key={i.key}>
              <Link to={i.link} data-testid={`data-health-${i.key}`} className="flex items-center gap-3 px-5 py-2.5 hover:bg-[#F7F5F1]">
                {i.severity === "warn" ? <AlertTriangle className="h-4 w-4 text-[#C86235] shrink-0" /> : <Info className="h-4 w-4 text-[#2E6F7A] shrink-0" />}
                <span className="text-sm text-[#45423C] flex-1 min-w-0">
                  {i.label} <b>({i.count})</b>
                  {i.detail && <span className="block text-xs text-[#8A8577] truncate">{i.detail}</span>}
                </span>
                <ChevronRight className="h-4 w-4 text-[#B9AE9A]" />
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
